<template>
  <div class="products-page flex-col">
    <div class="products-page__content flex-col">
      <div class="products-masthead flex-col">
        <app-header
          class="products-navigation"
          title="产品体系"
          :brand-icon="require('@/assets/pages/products/images/5bade0d14f153dc0482890a1714c3102.png')"
          :menu-icon="require('@/assets/pages/products/images/218a3ca96f0717ac33672fee71e573e7.png')"
        />
      </div>
      <div class="products-hero flex-col">
        <span class="products-hero__title">产品体系中心</span>
        <span class="products-hero__description">
          从高中阶段、准大学阶段，
          <br />
          到大学阶段，陪伴学涯每一步成长
        </span>
      </div>
      <div class="products-catalog flex-col">
        <div class="products-stage-filter" role="tablist" aria-label="产品阶段">
          <button
            v-for="stage in stageDefinitions"
            :key="stage.key"
            class="products-stage-filter__button"
            :class="{ 'products-stage-filter__button--active': activeStageKey === stage.key }"
            type="button"
            role="tab"
            :aria-selected="activeStageKey === stage.key ? 'true' : 'false'"
            @click="selectStage(stage.key)"
          >
            {{ stage.title }}
          </button>
        </div>
        <div class="products-category-filter flex-row">
          <button
            v-for="category in activeStage.filters"
            :key="category.value"
            class="products-category-filter__button"
            :class="{ 'products-category-filter__button--active': activeCategory === category.value }"
            type="button"
            :aria-pressed="activeCategory === category.value ? 'true' : 'false'"
            @click="activeCategory = category.value"
          >
            {{ category.label }}
          </button>
        </div>
        <div class="products-catalog__grid">
          <article
            v-for="product in visibleProducts"
            :key="product.id"
            class="products-catalog__card flex-col"
          >
            <div
              class="products-catalog__card-media"
              :class="{ 'products-catalog__card-media--collage': product.images.length > 1 }"
            >
              <img
                v-for="(image, imageIndex) in product.images"
                :key="`${product.id}-${imageIndex}`"
                class="products-catalog__card-image"
                referrerpolicy="no-referrer"
                :src="image"
                :alt="imageIndex === 0 ? product.title : ''"
              />
            </div>
            <div
              class="products-catalog__card-category flex-col"
              :class="`products-catalog__card-category--${product.category}`"
            >
              <span class="products-catalog__card-category-label">{{ categoryLabel(product.category) }}</span>
            </div>
            <span class="products-catalog__card-title">{{ product.title }}</span>
            <span class="products-catalog__card-description">{{ product.description }}</span>
            <button
              class="products-catalog__card-consultation flex-row justify-between"
              type="button"
              @click="openProductConsultation"
            >
              <span class="products-catalog__card-consultation-label">产品咨询</span>
              <img
                class="products-catalog__card-arrow"
                referrerpolicy="no-referrer"
                :src="consultationArrow"
                alt=""
              />
            </button>
          </article>
        </div>
        <app-footer class="products-page__footer" />
      </div>
      <app-floating-actions ref="floatingActions" />
    </div>
  </div>
</template>
<script>
import AppFloatingActions from '@/components/actions/AppFloatingActions.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AppHeader from '@/components/navigation/AppHeader.vue'
import highSchoolVolunteerHome from '@/assets/pages/products/images/high-school-volunteer-home.png'
import highSchoolVolunteerList from '@/assets/pages/products/images/high-school-volunteer-list.png'
import highSchoolVolunteerDetail from '@/assets/pages/products/images/high-school-volunteer-detail.png'
import highSchoolTeacherSystem from '@/assets/pages/products/images/high-school-teacher-system.png'
import highSchoolParentCourse from '@/assets/pages/products/images/high-school-parent-course.png'
import highSchoolCustomService from '@/assets/pages/products/images/high-school-custom-service.png'
import preUniversityGuide from '@/assets/pages/products/images/pre-university-guide.png'
import preUniversityOffice from '@/assets/pages/products/images/pre-university-office.png'
import preUniversityLearning from '@/assets/pages/products/images/pre-university-learning.png'
import preUniversityCampusLife from '@/assets/pages/products/images/pre-university-campus-life.png'
import preUniversityBootcamp from '@/assets/pages/products/images/pre-university-bootcamp.png'
import preUniversityCoding from '@/assets/pages/products/images/pre-university-coding.png'
import universityAppHome from '@/assets/pages/products/images/university-app-home.png'
import universityAppArticles from '@/assets/pages/products/images/university-app-articles.png'
import universityAppPlanning from '@/assets/pages/products/images/university-app-planning.png'
import universitySciService from '@/assets/pages/products/images/university-sci-service.png'

const stageDefinitions = [
  {
    key: 'high-school',
    title: '高中阶段',
    filters: [
      { label: '全部', value: 'all' },
      { label: '软件应用', value: 'software' },
      { label: '精品课程', value: 'course' },
      { label: '定制服务', value: 'service' }
    ],
    products: [
      {
        id: 'high-school-volunteer-card',
        category: 'software',
        title: '东大一帆志愿卡',
        description: '专为辽宁新高考量身打造，贴合本地报考规则与录取数据，支持AI个性规划。',
        images: [highSchoolVolunteerHome, highSchoolVolunteerList, highSchoolVolunteerDetail]
      },
      {
        id: 'high-school-teacher-system',
        category: 'software',
        title: '教师端填报系统',
        description: '专为辽宁地区填报师研发，实现学生批量多方案管理，可填报普通批与提前批志愿。',
        images: [highSchoolTeacherSystem]
      },
      {
        id: 'high-school-parent-course',
        category: 'course',
        title: '家长课堂',
        description: '由大学教授、资深导师组成授课团队，通过线上线下结合形式为家长解惑。',
        images: [highSchoolParentCourse]
      },
      {
        id: 'high-school-custom-service',
        category: 'service',
        title: '高端1V1定制升学服务',
        description: '由资深规划师组成专属定制服务小组，为学生提供个性化、一对一的升学规划服务。',
        images: [highSchoolCustomService]
      }
    ]
  },
  {
    key: 'pre-university',
    title: '准大学生阶段',
    filters: [
      { label: '全部', value: 'all' },
      { label: '游学营地', value: 'camp' },
      { label: '精品课程', value: 'course' }
    ],
    products: [
      {
        id: 'pre-university-guide',
        category: 'course',
        title: '大学学习必修指南',
        description: '由985高校导师、资深规划师共同编著，是准大学生入学必备工具书。',
        images: [preUniversityGuide]
      },
      {
        id: 'pre-university-office',
        category: 'camp',
        title: 'AI+办公软件深度解析',
        description: '办公技能进阶、AI高效赋能、复杂场景适配、打造办公全能型学子。',
        images: [preUniversityOffice]
      },
      {
        id: 'pre-university-learning',
        category: 'camp',
        title: 'AI+学习',
        description: '搭建高效学习体系、AI提升效率、解决记忆/规划痛点、适配备考/专业课场景。',
        images: [preUniversityLearning]
      },
      {
        id: 'pre-university-campus-life',
        category: 'camp',
        title: '我是大学生(学涯+口才)',
        description: '明确学涯规划、提升口才能力、破解社交胆怯、适配面试/汇报场景。',
        images: [preUniversityCampusLife]
      },
      {
        id: 'pre-university-bootcamp',
        category: 'camp',
        title: 'AI全能成长集训营',
        description: 'AI 硬核技能速成 + 学涯规划破局 + 名企名校赋能 + 4 年全程陪跑，一站式赋能。',
        images: [preUniversityBootcamp]
      },
      {
        id: 'pre-university-coding',
        category: 'camp',
        title: 'Al+Codin+Python',
        description: '零基础编程入门、AI降低门槛、掌握Python与小程序研发、打造技能优势。',
        images: [preUniversityCoding]
      }
    ]
  },
  {
    key: 'university',
    title: '大学阶段',
    filters: [
      { label: '全部', value: 'all' },
      { label: '软件应用', value: 'software' },
      { label: '定制服务', value: 'service' }
    ],
    products: [
      {
        id: 'university-growth-app',
        category: 'software',
        title: '大学赋能小程序',
        description: '集资讯、学习、赛事、升学于一体的大学生全周期成长服务平台。',
        images: [universityAppHome, universityAppArticles, universityAppPlanning]
      },
      {
        id: 'university-sci-service',
        category: 'service',
        title: 'SCl论文学术赋能服务',
        description: '聚焦大学生保研评优核心需求，提供核心期刊论文、发明专利全流程一对一指导服务。',
        images: [universitySciService]
      }
    ]
  }
]

const defaultStageKey = 'high-school'

function resolveInitialStageKey(routeStageKey) {
  const hasMatchingStage = stageDefinitions.some(stage => stage.key === routeStageKey)
  return hasMatchingStage ? routeStageKey : defaultStageKey
}

export default {
  name: 'ProductsView',
  components: { AppFloatingActions, AppFooter, AppHeader },
  data() {
    return {
      stageDefinitions,
      activeStageKey: resolveInitialStageKey(this.$route.query.stage),
      activeCategory: 'all',
      consultationArrow: require('@/assets/pages/products/images/43a11f9bf5c6fc25380b1a7b7ffd0b83.png')
    }
  },
  computed: {
    activeStage() {
      return this.stageDefinitions.find(stage => stage.key === this.activeStageKey)
        || this.stageDefinitions[0]
    },
    visibleProducts() {
      if (this.activeCategory === 'all') {
        return this.activeStage.products
      }

      return this.activeStage.products.filter(product => product.category === this.activeCategory)
    }
  },
  methods: {
    openProductConsultation() {
      if (this.$refs.floatingActions) {
        this.$refs.floatingActions.openContact()
      }
    },
    selectStage(stageKey) {
      if (this.activeStageKey === stageKey) {
        return
      }

      this.activeStageKey = stageKey
      this.activeCategory = 'all'
    },
    categoryLabel(categoryKey) {
      const category = this.activeStage.filters.find(item => item.value === categoryKey)
      return category ? category.label : ''
    }
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/products/styles/index.response.css" />
